import React from 'react';
import { List } from '@mui/material';
import { Theme } from '@mui/material/styles';

import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';

import { ProductApi } from 'common/types';

import { useSelector } from 'react-redux';
import * as UserSelectors from 'selectors/UserSelectors';
import { isProductEditableByUser } from 'common/modules/products/utils';
import OrderableListItem from './OrderableListItem';
import { getProductImageSrc } from 'common/utils/productUtils';

interface Props {
	products: ProductApi[];
	onMoveUp?: (productId: string, currentIndex: number) => void;
	onMoveDown?: (productId: string, currentIndex: number) => void;
}

const ProductList = (props: Props) => {
	const classes = useStyles();

	const userAccess = useSelector(UserSelectors.userActiveShopAccess)!;

	const { products, onMoveUp, onMoveDown } = props;

	const handleMove = (direction: 'up' | 'down') => (productId: string) => {
		const currentIndex = products.findIndex((p) => p.id === productId);
		if (direction === 'up') {
			onMoveUp?.(productId, currentIndex);
		} else {
			onMoveDown?.(productId, currentIndex);
		}
	};

	const renderItem = (product: ProductApi, index: number) => {
		return (
			<OrderableListItem
				id={product.id}
				key={product.id}
				label={product.name.def}
				image={getProductImageSrc(product)}
				onMoveUp={handleMove('up')}
				canMoveUp={index !== 0}
				onMoveDown={handleMove('down')}
				canMoveDown={index !== products.length - 1}
				disabled={!isProductEditableByUser(product, userAccess)}
			/>
		);
	};

	return <List className={classes.list}>{products.map(renderItem)}</List>;
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		list: {
			width: '100%',
		},
	}),
);

export default ProductList;
